module.exports = __webpack_public_path__ + "static/media/press.ea55b77c.jpg";